import {
	GET_INSURANCE_COMPANIES_STATISTICS,
	GET_INSURANCE_COMPANIES_STATISTICS_SUCCESS,
	GET_INSURANCE_COMPANIES_STATISTICS_FAIL,
	GET_INSURANCE_COMPANIES_STATISTICS_RESET,
} from '../actions/getInsuranceCompaniesStatisticsAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getInsuranceCompaniesStatisticsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INSURANCE_COMPANIES_STATISTICS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_INSURANCE_COMPANIES_STATISTICS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_INSURANCE_COMPANIES_STATISTICS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_INSURANCE_COMPANIES_STATISTICS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getInsuranceCompaniesStatisticsReducer;
